import { useSelector } from 'react-redux';
import { actionToggleSlidebar } from '@/store/slide-bar';
import useActions from '@/hooks/useActions';
import { useEffect, useRef } from 'react';

export default function useSlideMenuCollapsedChange<T>(collapsedVal: T, unCollapsedVal: T) {
  const sideBar = useSelector((state: any) => state.sideBar);
  const actions = useActions({ actionToggleSlidebar });

  if (sideBar.collapsed) return [collapsedVal, sideBar.collapsed, actions.actionToggleSlidebar];
  else return [unCollapsedVal, sideBar.collapsed, actions.actionToggleSlidebar];
}

export function useSlideMenuCollapse({ delay = 0 } = {}) {
  const actions = useActions({ actionToggleSlidebar });

  const optionsRef = useRef({ delay });

  useEffect(() => {
    let mounted = true;

    if (!optionsRef.current.delay) innerCollapse();
    else setTimeout(innerCollapse, optionsRef.current.delay);

    function innerCollapse() {
      if (!mounted) return;
      actions.actionToggleSlidebar({ collapsed: true });
    }

    return () => {
      mounted = false;
      actions.actionToggleSlidebar({ collapsed: false });
    };
    // eslint-disable-next-line
  }, []);
}
